
import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import TitanLoginPage from '../TitanLoginPage/TitanLoginPage';
import './LoginPage.scss';
import { Redirect } from 'react-router-dom';

const LoginPage = () => {
  const flags = useFlags();
  const showTitanLogin = flags.enableLoginForTitanUsers;
  
  if (showTitanLogin) {
    return <TitanLoginPage />;
  } else {
    return <Redirect to={'/app/feature/home'} />;
  }
}

export default LoginPage;